export const ACCOUNT_ENUM = {
    PRIMETIME: 'PRIMETIME',
    DASHBOARD: 'DASHBOARD',
    TOURNAMENTS: 'TOURNAMENTS',
    TEAMS: 'TEAMS',
    SETTINGS: 'SETTINGS',
    PROFILE: 'PROFILE',
    ACCOUNT: 'ACCOUNT'
}